import gql from 'graphql-tag';

export const NodeAlertFragment = gql`
  fragment NodeAlertFragment on NodeAlert {
    alertName
    alertStatus
    cluster
    clusterOrg
    description
    grafanaDashboard
    labels
    node
    pod
    occurrences
  }
`;

export const RunIssueQuery = gql`
  query RunIssueQuery(
    $entityName: String!
    $projectName: String!
    $runName: String!
    $start: DateTime!
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      run(name: $runName) {
        id
        nodeAlertsHistory(start: $start) {
          ...NodeAlertFragment
        }
      }
    }
  }
  ${NodeAlertFragment}
`;
